import React from 'react'
import PropTypes from 'prop-types'

import RecommendationLevelCard from '../RecommendationLevelCard/RecommendationLevelCard'
import LoadingSpinner from '../../leevo_ui/LoadingSpinner/LoadingSpinner'
import { Accordion } from '../../ui/accordion'

function Recommendations({ recommendations, isLoading }) {
  if (!recommendations || recommendations.length === 0 || isLoading) {
    return (
      <div className="mx-1 bg-white shadow rounded-xl print:hidden" data-cy="recommendation-guidance">
        <div className="flex items-start justify-between p-5 border-b border-gray-300">
          <div className="text-lg font-medium text-gray-900">
            <p>Recommendations</p>
          </div>
        </div>
        <p className="px-5 py-4 text-sm text-gray-600">
          {isLoading ? <LoadingSpinner className="flex justify-center" /> : 'Check attendance to see recommendations.'}
        </p>
      </div>
    )
  } else {
    const skillLevelIds = [...new Set(recommendations.map(({ skillLevel }) => skillLevel.id))]
    return (
      <Accordion type="multiple" className="space-y-3">
        {skillLevelIds.map((levelId) => (
          <RecommendationLevelCard
            recommendations={recommendations.filter((rec) => rec.skillLevel.id === levelId)}
            key={levelId}
          />
        ))}
      </Accordion>
    )
  }
}

Recommendations.propTypes = {
  recommendations: PropTypes.arrayOf(
    PropTypes.shape({
      skillLevel: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    })
  ),
  isLoading: PropTypes.bool
}

export default Recommendations
